// 매물유형별 키워드 데이터 (스토리형용)
// estateCategory: land(토지), commercial(상업용), residential(주거용)

export const STORY_KEYWORDS = {
    land: [
        {
            label: "입지 및 교통",
            defaultOpen: true,
            keywords: ["역세권", "5분거리", "10분거리", "대로변", "코너자리", "버스정류장", "진출입원활", "IC인근", "접근성우수", "가시성최고", "진입도로확보", "도로접함", "2차선접"],
        },
        {
            label: "공간 및 현황",
            defaultOpen: false,
            keywords: ["채광우수", "반듯한모양", "평탄화완료", "구획정리"],
        },
        {
            label: "시설 및 인프라",
            defaultOpen: false,
            keywords: ["상하수도인입", "도시가스인입"],
        },
        {
            label: "거래 및 법률",
            defaultOpen: false,
            keywords: ["급매물", "가성비최고", "금액조정가능", "지목변경가능", "산업단지내", "개발제한구역", "건축가능부지", "개발행위허가완료"],
        },
        {
            label: "투자 및 마케팅",
            defaultOpen: false,
            keywords: ["강력추천", "귀한매물", "파노라마뷰", "조망권우수", "지가상승기대", "개발호재풍부"],
        },
    ],
    commercial: [
        {
            label: "입지 및 교통",
            defaultOpen: true,
            keywords: ["역세권", "대로변", "코너자리", "진출입원활", "IC인근", "가시성최고", "유동인구풍부", "메인상권"],
        },
        {
            label: "공간 및 현황",
            defaultOpen: false,
            keywords: ["신축급", "첫입주", "층고높음", "개방감확보", "반듯한모양"],
        },
        {
            label: "시설 및 인프라",
            defaultOpen: false,
            keywords: ["자주식주차", "기계식주차", "엘리베이터유", "시스템에어컨", "개별난방", "중앙난방", "내부화장실", "호이스트설치", "KW증설가능"],
        },
        {
            label: "거래 및 법률",
            defaultOpen: false,
            keywords: ["급매물", "가성비최고", "수익률우수", "산업단지내", "개발제한구역", "권리금없음", "렌트프리협의", "증축가능"],
        },
        {
            label: "투자 및 마케팅",
            defaultOpen: false,
            keywords: ["귀한매물", "지가상승기대", "개발호재풍부"],
        },
    ],
    residential: [
        {
            label: "입지 및 교통",
            defaultOpen: true,
            keywords: ["역세권", "버스정류장", "접근성우수", "도보통학권"],
        },
        {
            label: "공간 및 현황",
            defaultOpen: false,
            keywords: ["신축급", "첫입주", "올수리완료", "마당넓은", "채광우수", "맞통풍구조", "분리형구조", "확장형평면", "펜트하우스"],
        },
        {
            label: "시설 및 인프라",
            defaultOpen: false,
            keywords: ["주차편리", "엘리베이터유", "시스템에어컨", "개별난방", "중앙난방", "풀옵션완비", "전기차충전기"],
        },
        {
            label: "거래 및 법률",
            defaultOpen: false,
            keywords: ["급매물", "가성비최고", "금액조정가능", "개발제한구역", "증축가능"],
        },
        {
            label: "투자 및 가치",
            defaultOpen: false,
            keywords: ["귀한매물", "조망권우수", "지가상승기대", "대장단지", "로얄층", "로얄동", "재개발구역", "재건축단지"],
        },
    ],
};

// 광고형 키워드 (매물유형 무관, 플랫 리스트, 최대 5개)
export const AD_KEYWORDS = [
    "초급매물", "급매", "역대급매", "가격절충가능",
    "선점필수", "시세차익보장", "미래가치확실",
    "상태최상", "파격특가", "줍줍찬스", "귀한매물",
    "단독급매", "로얄층선점", "즉시입주", "특급조망",
    "실주거강추", "특올수리", "투자보장",
];
